import { loadable } from 'utils';

export const Line = loadable(() => import('./Line'), {});
